import {Pipe, PipeTransform} from '@angular/core';
import {Diensten} from './diensten';

@Pipe({
    name: 'zahDienst',
    standalone: false
})
export class DienstPipe implements PipeTransform {
  transform(dienstId: string, diensten: Diensten): string {
    if (!diensten) {
      return '';
    } else {
      const dienstWithid = diensten.getDienst(dienstId);
      return dienstWithid ? dienstWithid.getLabel() : 'Onbekend';
    }
  }
}
